// @flow
import React, {Component} from 'react';
import {StyleSheet, View, Platform} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';

import {
  GradientPage,
  FullButton,
  SecondaryFullButton,
} from '../../../components/common';
import {PageTitle, LoginForm} from '../../../components/signUp';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import config from '../../../config';
import * as Navigation from '../../../lib/navigation.js';
import PasswordService from '../../../lib/password';

class CreateAccount extends Component<Props, State> {
  state = {
    isCGUCheckboxChecked: false,
    passwordProgress: 0,
  };

  styles = getStyles();

  setCGUCheckboxValue = (checkboxValue: boolean) =>
    this.setState({isCGUCheckboxChecked: checkboxValue});

  goToLoginPage = () => {
    if (!this.props.goToLoginPage) {
      return Navigation.navigate('authDuringSignUp');
    }
    this.props.goToLoginPage();
  };

  submit = () => {
    if (config.requireCGUOnSignUp) {
      this.state.isCGUCheckboxChecked && this.props.handleSubmit();
    } else {
      this.props.handleSubmit();
    }
  };

  render() {
    const styles = this.styles;
    return (
      <GradientPage iosEdges={['top','bottom']} maxWidth={600}>
        <KeyboardAwareScrollView testID="createAccountScrollView" extraHeight={90} enableOnAndroid="true">
          <PageTitle
            title={I18n.t('SignUp.CreateAccount.title')}
            style={styles.title}
          />
          <View style={styles.errorContainer}>
            {this.props.submitFailed && this.props.error && (
              <Text style={styles.error}>{this.props.error}</Text>
            )}
          </View>
          <View style={styles.form}>
            <LoginForm
              setCGUCheckboxValue={this.setCGUCheckboxValue}
              handleSubmit={this.submit}
              withPasswordStrength
              withTermsCheckbox={config.requireCGUOnSignUp}
              emailTestID={'emailDuringCreateAccount'}
              passwordTestID={'passwordDuringCreateAccount'}
              onPasswordStrengthChange={(progress) => this.setState({ passwordProgress: progress })}
            />
            <FullButton
              onPress={this.submit}
              text={I18n.t('validate')}
              isLoading={this.props.isLoading}
              testID={'validateCreateAccountButton'}
              style={styles.primaryButton}
              disabled={(config.requireCGUOnSignUp && !this.state.isCGUCheckboxChecked) || this.state.passwordProgress < PasswordService.MIN_PROGRESS_TO_SUBMIT}
            />
            {this.props.showAlreadyHaveAccount && (
              <SecondaryFullButton
                onPress={this.goToLoginPage}
                text={I18n.t('SignUp.CreateAccount.alreadyHaveAccount')}
                style={styles.secondaryButtonContainer}
                emphasizeSubText
              />
            )}
          </View>
        </KeyboardAwareScrollView>
      </GradientPage>
    );
  }
}

type Props = DispatchProps & StateProps & OwnProps;

type State = {
  isCGUCheckboxChecked: boolean,
};

export type DispatchProps = {
  goToLoginPage?: Function,
  onSubmit?: Function,
};

export type StateProps = {
  initialValues: {
    email: string,
    password: string,
    optionExternalCommercial: boolean,
    optionInternalCommercial: boolean,
  },
  isLoading: boolean,
  showAlreadyHaveAccount: boolean,
};

type OwnProps = {
  error: string,
  handleSubmit: Function,
  submitFailed: Function,
};

function getStyles() {
  return StyleSheet.create({
    title: {
      marginHorizontal: 40,
      marginTop: 0,
      fontSize: Platform.OS === 'ios' ? 19 : 22,
      textAlign: 'center',
    },
    error: {
      backgroundColor: 'transparent',
      color: theme.primaryColor,
      fontSize: 16,
      textAlign: 'center',
    },
    errorContainer: {
      height: 20,
      marginTop: 12,
    },
    form: {
      alignItems: 'stretch',
      marginHorizontal: 20,
    },
    primaryButton: {
      marginTop: 12,
    },
    secondaryButtonContainer: {
      marginTop: 8,
    },
  });
}

export default CreateAccount;
